module.exports = __webpack_public_path__ + "static/forms-cta-save-dont-99817657bf77d95bd131743fbbabb606.png";